<div
  class="ndf-management-item"
  [ngClass]="{
    'ndf-management-item--collapsed': ndfOperation?.colapsed,
    'ndf-management-item--fixed': ndfOperation?.selected,
  }">
  <div
    class="ndf-management-item__header"
    *ngIf="!ndfOperation?.colapsed"
    appLongPress
    (dblclick)="handleDoubleClickHeader()"
    (longPress)="handleLongPress()">
    <div class="d-flex align-items-center">
      <button (click)="moveOrder('move-up')" class="arrow-button" *ngIf="canMoveUp()">◀</button>
      <h2>#{{ ndfOperation?.sequentialId }} - {{ ndfOperation?.order }}</h2>
      <button (click)="moveOrder('move-down')" class="arrow-button" *ngIf="canMoveDown()">▶</button>
    </div>
    <app-action-menu
      (dblclick)="handleDoubleClickHeader()"
      [items]="actionIcons"
      [horientation]="'vertical'"
      (sendItemClick)="handleActionMenu($event)"></app-action-menu>
  </div>
  <div
    class="ndf-management-item__header ndf-management-item__header--clean"
    *ngIf="!ndfOperation?.colapsed"
    (dblclick)="handleDoubleClickHeader()">
    <div *ngIf="ndfOperation?.operationStatus && ndfOperation?.id" class="pill ms-1">
      <span class="text-sm">{{ operationStatusLabel }}</span>
    </div>
    <div *ngIf="ndfOperation?.financialStatus && ndfOperation?.id" class="pill ms-1">
      <span class="text-sm">{{ financialStatusLabel }}</span>
    </div>
    <div *ngIf="ndfOperation?.composition && ndfOperation?.id" class="pill ms-1">
      <span class="text-sm">{{ compositionLabel }}</span>
    </div>
  </div>
  <div class="ndf-management-item__content" *ngIf="!ndfOperation?.colapsed">
    <form *ngIf="demandForm" [formGroup]="demandForm" appAutoFormGroup>
      <!-- INÍCIO Modalidade (OperationStrategyType) -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <app-select
          class="w-100 custom-disabled-no-opacity"
          [ngClass]="{
            operationStrategyType: index === 0,
          }"
          [options]="operationStrategyTypeOptions"
          [selectedOption]="selectedOperationStrategyType"
          [theme]="'clean'"
          [error]="false"
          [formGroup]="demandForm"
          [controlName]="demandRegisterProps.operationStrategyType"
          [disabled]="!canEdit"
          (sendSelectedOption)="handleOptionChange($event, 'operationStrategyType')"
          [placeholder]="tk.User.Select | t">
        </app-select>

        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.operationStrategyType
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.operationStrategyType)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM Modalidade -->
      <!-- INICIO Instituição financeira -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <!-- TODO: Comentado no "Backlog-item-1013", verificar se pode ser removido  -->
        <!-- <div
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected':
              ndfOperation?.controlNameHighlighted?.includes(
                demandRegisterProps.financialInstitution
              ),
            'item__icon--disabled':
              showApplyButton || demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__highlight"
            (click)="
              handleFormControlAction(
                'highlight',
                demandRegisterProps.financialInstitution
              )
            ">
            <svg
              width="15"
              height="20"
              viewBox="0 0 15 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.55015 16.1997L11.7251 9.99972H7.72515L8.45015 4.32472L3.82515 10.9997H7.30015L6.55015 16.1997ZM4.57715 19.442L5.57715 12.4997H0.952148L9.1924 0.605469H10.4231L9.4329 8.49972H14.9326L5.8079 19.442H4.57715Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div> -->
        <!-- TODO: Comentado no "Backlog-item-1013", verificar se pode ser removido  -->

        <app-select
          class="w-100 custom-disabled-no-opacity"
          [options]="financialInstitutionsOptions"
          [selectedOption]="selectedFinancialInstitution"
          [theme]="'clean'"
          [error]="false"
          [formGroup]="demandForm"
          [controlName]="demandRegisterProps.financialInstitution"
          [disabled]="!canEdit"
          (sendSelectedOption)="handleOptionChange($event, 'financialInstitution')"
          [placeholder]="tk.Management.NdfSelectTheBank | t">
          <ng-template let-item>
            <app-bank-logo [code]="item?.data?.compensationCode" />
            {{ item.label }}
          </ng-template>
        </app-select>

        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.financialInstitution
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.financialInstitution)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM Instituição financeira -->
      <!-- INÍCIO Data -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border custom-disabled-no-opacity">
        <app-calendar
          [placeholder]="(tk.Management.NdfInsertDate | t) || ''"
          [disabled]="!canEdit"
          [date]="demandForm.get(demandRegisterProps.operationDate)?.value || ''"
          [theme]="'clean'"
          [debounceInputTime]="3000"
          (sendCalendarValue)="handleCalendarValue($event, demandRegisterProps.operationDate)" />
        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.operationDate
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.operationDate)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM Data -->
      <!-- INÍCIO Vencimento -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border custom-disabled-no-opacity">
        <app-calendar
          [placeholder]="(tk.Management.NdfEnterDueDate | t) || ''"
          [date]="demandForm.get(demandRegisterProps.dueAt)?.value || ''"
          [minDate]="minDueDate"
          [disabled]="!canEdit"
          [theme]="'clean'"
          [error]="false"
          [formGroup]="demandForm"
          [controlName]="demandRegisterProps.dueAt"
          [debounceInputTime]="3000"
          (sendCalendarValue)="handleCalendarValue($event, demandRegisterProps.dueAt)" />
        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.dueAt
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.dueAt)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM Vencimento -->
      <!-- INÍCIO Corridos/Úteis -->
      <div class="d-flex">
        <div class="w-100">
          <div
            class="ndf-management-item__content__item ndf-management-item__content__item--2x ndf-management-item__content__item--border">
            <!-- <label>{{ tk.Management.NdfCalendarDays | t }}</label> -->
            <app-input
              [type]="'number'"
              [theme]="'clean'"
              [value]="demandForm.get(demandRegisterProps.daysCount)?.value || ''"
              [placeholder]="(tk.Management.NdfInsertDays | t) || ''"
              [controlName]="demandRegisterProps.daysCount"
              [required]="false"
              [readonly]="!canEdit"
              (sendInputValue)="handleInputNumber($event, 'daysCount')" />
          </div>
        </div>
        <div class="w-100">
          <div
            class="ndf-management-item__content__item ndf-management-item__content__item--2x ndf-management-item__content__item--border">
            <!-- <label>{{ tk.Management.NdfWorkingDays | t }}</label> -->
            <app-input
              [type]="'number'"
              [theme]="'clean'"
              [value]="demandForm.get(demandRegisterProps.businessDaysCount)?.value || ''"
              [placeholder]="(tk.Management.NdfInsertDays | t) || ''"
              [controlName]="demandRegisterProps.businessDaysCount"
              [required]="false"
              [readonly]="!canEdit"
              (sendInputValue)="handleInputNumber($event, 'businessDaysCount')" />
          </div>
        </div>
      </div>
      <!-- FIM Corridos/Úteis -->

      <!-- no arquivo ndf-management-item.component.html -->

      <!-- INÍCIO Parcelas -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <div class="installments-container">
          <p-multiSelect
            [options]="installmentsOptions"
            [(ngModel)]="selectedInstallments"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="
              !demand?.loanOperationId
                ? 'Selecione um empréstimo para vincular parcelas'
                : installedInstallmentsCount > 0
                  ? installedInstallmentsCount +
                    (installedInstallmentsCount === 1
                      ? ' parcela vinculada'
                      : ' parcelas vinculadas')
                  : '{{ tk.Management.LinkInstallments | t }}'
            "
            [selectedItemsLabel]="getSelectedItemsLabel()"
            [showToggleAll]="true"
            [maxSelectedLabels]="0"
            [disabled]="!demand?.loanOperationId"
            (onChange)="handleInstallmentsChange($event)"
            (onShow)="ensureInstallmentsSelected()">
            <ng-template let-item pTemplate="item">
              <div class="installment-item" [ngClass]="{ 'flat-fee': item.isFlatFee }">
                <span>{{ item.label }}</span>
              </div>
            </ng-template>

            <ng-template pTemplate="selectedItems" let-value>
              <div *ngIf="value?.length" class="selected-items">
                {{
                  value.length === 0
                    ? '1' + (tk.Management.LinkedInstallment | t)
                    : value.length + ' ' + (tk.Management.LinkedInstallments | t)
                }}
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
      <!-- FIM Parcelas -->

      <!-- INÍCIO Notional -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <app-input
          [type]="'number'"
          [theme]="'clean'"
          [minFractionDigits]="2"
          [prefix]="!isSwapFieldsReadonly ? 'R$ ' : ''"
          [value]="demandForm.get(demandRegisterProps.notionalAmount)?.value || ''"
          [placeholder]="(tk.Management.NdfInsertNotional | t) || ''"
          [controlName]="demandRegisterProps.notionalAmount"
          [required]="false"
          [readonly]="!canEdit"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.notionalAmount)" />
        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.notionalAmount
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.notionalAmount)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM Notional -->
      <!-- INÍCIO Forward -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isForwardRateReadonly,
        }">
        <!-- TODO: Comentado no "Backlog-item-1013", verificar se pode ser removido  -->
        <!-- <div
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected':
              ndfOperation?.controlNameHighlighted?.includes(
                demandRegisterProps.forwardRate
              ),
            'item__icon--disabled':
              showApplyButton || demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__highlight"
            (click)="
              handleFormControlAction(
                'highlight',
                demandRegisterProps.forwardRate
              )
            ">
            <svg
              width="15"
              height="20"
              viewBox="0 0 15 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.55015 16.1997L11.7251 9.99972H7.72515L8.45015 4.32472L3.82515 10.9997H7.30015L6.55015 16.1997ZM4.57715 19.442L5.57715 12.4997H0.952148L9.1924 0.605469H10.4231L9.4329 8.49972H14.9326L5.8079 19.442H4.57715Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div> -->
        <!-- TODO: Comentado no "Backlog-item-1013", verificar se pode ser removido  -->
        <span *ngIf="isForwardRateReadonly">
          {{
            demandForm.get(demandRegisterProps.forwardRate)?.value
              ? (demandForm.get(demandRegisterProps.forwardRate)?.value | vaultFormatCurrency: 4)
              : '-'
          }}
        </span>
        <app-input
          *ngIf="!isForwardRateReadonly"
          [hidden]="isForwardRateReadonly"
          [disabled]="isForwardRateReadonly"
          [type]="'number'"
          [theme]="'clean'"
          [value]="demandForm.get(demandRegisterProps.forwardRate)?.value ?? ''"
          [minFractionDigits]="4"
          [readonly]="!canEdit"
          [placeholder]="(tk.Management.NdfInsertForward | t) || ''"
          [controlName]="demandRegisterProps.forwardRate"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.forwardRate)" />
        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.forwardRate
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.forwardRate)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM Forward -->
      <!-- INÍCIO CAP -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isCapReadonly,
        }">
        <span *ngIf="isCapReadonly">
          {{
            isCallSpread || isCallVanilla
              ? '-'
              : demandForm.get(demandRegisterProps.capValue)?.value
                ? (demandForm.get(demandRegisterProps.capValue)?.value | vaultFormatCurrency: 4)
                : '-'
          }}
        </span>
        <app-input
          *ngIf="!isCapReadonly"
          [type]="'number'"
          [hidden]="isCapReadonly"
          [theme]="'clean'"
          [value]="demandForm.get(demandRegisterProps.capValue)?.value || ''"
          [minFractionDigits]="4"
          [readonly]="!canEdit || isCapReadonly"
          [disabled]="isCapReadonly"
          [placeholder]="(tk.Management.NdfInsertCap | t) || ''"
          [controlName]="demandRegisterProps.capValue"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.capValue)" />
        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.capValue
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.capValue)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM CAP -->
      <!-- INÍCIO ReferenceExchangeRate -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <app-input
          [type]="'number'"
          [theme]="'clean'"
          [value]="demandForm.get(demandRegisterProps.referenceExchangeRate)?.value || ''"
          [minFractionDigits]="4"
          [readonly]="!canEdit"
          [placeholder]="(tk.Management.NdfReferenceExchange | t) || ''"
          [controlName]="demandRegisterProps.referenceExchangeRate"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, 'referenceExchangeRate')" />
        <div
          *ngIf="operationStatusBlockEdition"
          class="item__icon px-2"
          [ngClass]="{
            'item__icon--selected': ndfOperation?.controlNameBlocked?.includes(
              demandRegisterProps.referenceExchangeRate
            ),
            'item__icon--disabled': demand?.operations?.length === 1,
          }">
          <div
            class="item__icon__block item__icon--disabled"
            (click)="handleFormControlAction('block', demandRegisterProps.referenceExchangeRate)">
            <svg
              width="16"
              height="20"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.30775 19.5C1.80908 19.5 1.38308 19.3234 1.02975 18.9703C0.676583 18.6169 0.5 18.1909 0.5 17.6923V8.30775C0.5 7.80908 0.676583 7.38308 1.02975 7.02975C1.38308 6.67658 1.80908 6.5 2.30775 6.5H3.5V4.5C3.5 3.25133 3.93783 2.18917 4.8135 1.3135C5.68917 0.437833 6.75133 0 8 0C9.24867 0 10.3108 0.437833 11.1865 1.3135C12.0622 2.18917 12.5 3.25133 12.5 4.5V6.5H13.6923C14.1909 6.5 14.6169 6.67658 14.9703 7.02975C15.3234 7.38308 15.5 7.80908 15.5 8.30775V17.6923C15.5 18.1909 15.3234 18.6169 14.9703 18.9703C14.6169 19.3234 14.1909 19.5 13.6923 19.5H2.30775ZM2.30775 18H13.6923C13.7821 18 13.8558 17.9712 13.9135 17.9135C13.9712 17.8558 14 17.7821 14 17.6923V8.30775C14 8.21792 13.9712 8.14417 13.9135 8.0865C13.8558 8.02883 13.7821 8 13.6923 8H2.30775C2.21792 8 2.14417 8.02883 2.0865 8.0865C2.02883 8.14417 2 8.21792 2 8.30775V17.6923C2 17.7821 2.02883 17.8558 2.0865 17.9135C2.14417 17.9712 2.21792 18 2.30775 18ZM8 14.75C8.48583 14.75 8.899 14.5798 9.2395 14.2395C9.57983 13.899 9.75 13.4858 9.75 13C9.75 12.5142 9.57983 12.101 9.2395 11.7605C8.899 11.4202 8.48583 11.25 8 11.25C7.51417 11.25 7.101 11.4202 6.7605 11.7605C6.42017 12.101 6.25 12.5142 6.25 13C6.25 13.4858 6.42017 13.899 6.7605 14.2395C7.101 14.5798 7.51417 14.75 8 14.75ZM5 6.5H11V4.5C11 3.66667 10.7083 2.95833 10.125 2.375C9.54167 1.79167 8.83333 1.5 8 1.5C7.16667 1.5 6.45833 1.79167 5.875 2.375C5.29167 2.95833 5 3.66667 5 4.5V6.5Z"
                fill="#9E9E9E" />
            </svg>
          </div>
        </div>
      </div>
      <!-- FIM ReferenceExchangeRate -->

      <!-- Campos específicos para Callspread e Call vanilla -->
      <!-- Campo Strike Buy - apenas para Call Spread e Call Vanilla -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isStrikeBuyReadonly,
        }">
        <span *ngIf="isStrikeBuyReadonly">
          {{
            demandForm.get(demandRegisterProps.strikeBuy)?.value
              ? (demandForm.get(demandRegisterProps.strikeBuy)?.value | vaultFormatCurrency: 4)
              : ' - '
          }}
        </span>

        <app-input
          *ngIf="!isStrikeBuyReadonly"
          [type]="'number'"
          [theme]="'clean'"
          [minFractionDigits]="4"
          [hidden]="isStrikeBuyReadonly"
          [value]="demandForm.get(demandRegisterProps.strikeBuy)?.value || ''"
          [readonly]="!canEdit"
          [placeholder]="(tk.Management.NdfStrikeBuy | t) || ''"
          [controlName]="demandRegisterProps.strikeBuy"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.strikeBuy)" />
      </div>

      <!-- Campo Strike Sell - apenas para Call Spread -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isStrikeSellReadonly,
        }">
        <span *ngIf="isStrikeSellReadonly">
          {{
            demandForm.get(demandRegisterProps.strikeSell)?.value
              ? (demandForm.get(demandRegisterProps.strikeSell)?.value | vaultFormatCurrency: 4)
              : ' - '
          }}
        </span>
        <app-input
          *ngIf="!isStrikeSellReadonly"
          [type]="'number'"
          [theme]="'clean'"
          [hidden]="isStrikeSellReadonly"
          [readonly]="!canEdit"
          [minFractionDigits]="4"
          [value]="demandForm.get(demandRegisterProps.strikeSell)?.value || ''"
          [placeholder]="(tk.Management.NdfStrikeSell | t) || ''"
          [controlName]="demandRegisterProps.strikeSell"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.strikeSell)" />
      </div>

      <!-- Campo Premio -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isPremiumReadonly,
        }">
        <span *ngIf="isPremiumReadonly">
          {{ demandForm.get(demandRegisterProps.premium)?.value || ' - ' }}
        </span>
        <app-input
          *ngIf="!isPremiumReadonly"
          [type]="'number'"
          [theme]="'clean'"
          [hidden]="isPremiumReadonly"
          [minFractionDigits]="2"
          [value]="demandForm.get(demandRegisterProps.premium)?.value || ''"
          [readonly]="!canEdit"
          [placeholder]="(tk.Management.NdfPremium | t) || ''"
          [controlName]="demandRegisterProps.premium"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.premium)" />
      </div>

      <!-- Campo Número de parcelas -->
      <!-- <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isSwapFieldsReadonly,
        }">
        <span *ngIf="isSwapFieldsReadonly">
          {{ demandForm.get(demandRegisterProps.numberOfInstallments)?.value || ' - ' }}
        </span>
        <app-input
          *ngIf="!isSwapFieldsReadonly"
          [type]="'number'"
          [theme]="'clean'"
          [hidden]="isSwapFieldsReadonly"
          [value]="demandForm.get(demandRegisterProps.numberOfInstallments)?.value || ''"
          [disabled]="isSwapFieldsReadonly"
          [placeholder]="(tk.Management.NdfInstallments | t) || ''"
          [controlName]="demandRegisterProps.numberOfInstallments"
          [required]="false"
          (sendInputValue)="handleInputNumber($event, demandRegisterProps.numberOfInstallments)" />
      </div> -->

      <!-- Indexador ativo -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isSwapFieldsReadonly,
        }">
        <span *ngIf="isSwapFieldsReadonly">
          {{ demandForm.get(demandRegisterProps.activeIndexer)?.value || ' - ' }}
        </span>
        <app-select
          *ngIf="!isSwapFieldsReadonly"
          class="w-100 custom-disabled-no-opacity"
          [options]="activeIndexerOptions"
          [selectedOption]="selectedActiveIndexer"
          [theme]="'clean'"
          [hidden]="isSwapFieldsReadonly"
          [disabled]="!canEdit"
          [error]="false"
          [formGroup]="demandForm"
          [controlName]="demandRegisterProps.activeIndexer"
          (sendSelectedOption)="handleOptionChange($event, 'activeIndexer')"
          [placeholder]="tk.User.Select | t">
        </app-select>
      </div>

      <!-- Indexador passivo -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isSwapFieldsReadonly,
        }"
        style="justify-content: unset">
        <span *ngIf="isPassiveIndexerReadonly">
          {{ demandForm.get(demandRegisterProps.passiveIndexer)?.value || ' - ' }}
        </span>
        <app-select
          *ngIf="!isPassiveIndexerReadonly"
          class="w-100 custom-disabled-no-opacity"
          [options]="passiveIndexerOptions"
          [selectedOption]="selectedPassiveIndexer"
          [theme]="'clean'"
          [hidden]="isPassiveIndexerReadonly"
          [error]="false"
          [formGroup]="demandForm"
          [disabled]="!canEdit"
          [controlName]="demandRegisterProps.passiveIndexer"
          (sendSelectedOption)="handleOptionChange($event, 'passiveIndexer')"
          [placeholder]="tk.User.Select | t">
        </app-select>
      </div>

      <!-- Taxa fixa ativo a.a.% -->

      <div class="d-flex">
        <div class="w-100">
          <div
            class="ndf-management-item__content__item ndf-management-item__content__item--2x ndf-management-item__content__item--border"
            [ngClass]="{
              'ndf-management-item__content__item--readonly': isSwapFieldsReadonly,
            }">
            <span *ngIf="isSwapFieldsReadonly">
              {{
                demandForm.get(demandRegisterProps.activeFixedRatePerYear)?.value
                  ? (demandForm.get(demandRegisterProps.activeFixedRatePerYear)?.value
                    | vaultFormatPercent: 4)
                  : '-'
              }}
            </span>
            <app-input
              *ngIf="!isSwapFieldsReadonly"
              [type]="'number'"
              [theme]="'clean'"
              [totalFractionDigits]="4"
              [value]="demandForm.get(demandRegisterProps.activeFixedRatePerYear)?.value || ''"
              [readonly]="!canEdit"
              [placeholder]="(tk.Management.NdfActiveFixedRatePerYear | t) || ''"
              [controlName]="demandRegisterProps.activeFixedRatePerYear"
              [required]="false"
              (sendInputValue)="
                handleInputNumber($event, demandRegisterProps.activeFixedRatePerYear)
              " />
          </div>
        </div>
        <div class="w-100">
          <div
            class="ndf-management-item__content__item ndf-management-item__content__item--2x ndf-management-item__content__item--border"
            [ngClass]="{
              'ndf-management-item__content__item--readonly': isSwapFieldsReadonly,
            }">
            <span *ngIf="isSwapFieldsReadonly">
              {{
                getDayCountConventionLabel(
                  demandForm.get(demandRegisterProps.dayCountConvention)?.value
                ) || ' - '
              }}
            </span>
            <app-select
              *ngIf="!isSwapFieldsReadonly"
              class="w-100 custom-disabled-no-opacity"
              [options]="dayCountConventionOptions"
              [selectedOption]="selectedDayCountConvention"
              [theme]="'clean'"
              [hidden]="isSwapFieldsReadonly"
              [error]="false"
              [formGroup]="demandForm"
              [controlName]="demandRegisterProps.dayCountConvention"
              [disabled]="!canEdit"
              (sendSelectedOption)="handleOptionChange($event, 'dayCountConvention')"
              [placeholder]="tk.User.Select | t">
            </app-select>
          </div>
        </div>
      </div>

      <!-- Taxa fixa passivo a.a.% -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [ngClass]="{
          'ndf-management-item__content__item--readonly': isSwapFieldsReadonly,
        }">
        <span *ngIf="isSwapFieldsReadonly">
          {{
            demandForm.get(demandRegisterProps.passiveFixedRatePerYear)?.value
              ? (demandForm.get(demandRegisterProps.passiveFixedRatePerYear)?.value
                | vaultFormatPercent: 4)
              : '-'
          }}
        </span>

        <app-input
          *ngIf="!isSwapFieldsReadonly"
          [type]="'number'"
          [theme]="'clean'"
          [totalFractionDigits]="5"
          [hidden]="isSwapFieldsReadonly"
          [value]="demandForm.get(demandRegisterProps.passiveFixedRatePerYear)?.value || ''"
          [readonly]="!canEdit"
          [placeholder]="''"
          [controlName]="demandRegisterProps.passiveFixedRatePerYear"
          [required]="false"
          (sendInputValue)="
            handleInputNumber($event, demandRegisterProps.passiveFixedRatePerYear)
          " />
      </div>
      <!-- Campo Fluxo de Juros - para SWAP -->
      <!-- <div
  class="ndf-management-item__content__item ndf-management-item__content__item--border"
  [ngClass]="{
    'ndf-management-item__content__item--readonly': isSwapFieldsReadonly
  }">
  <span *ngIf="isSwapFieldsReadonly">
    {{ getInterestFlowLabel(demandForm.get(demandRegisterProps.interestFlow)?.value) || ' - ' }}
  </span>
  <app-select
    *ngIf="!isSwapFieldsReadonly"
    class="w-100 custom-disabled-no-opacity"
    [options]="interestFlowOptions"
 (tk.Management.NdfPassiveFixedRatePerYear | t) ||    [selectedOption]="selectedInterestFlow"
    [theme]="'clean'"
    [hidden]="isSwapFieldsReadonly"
    [error]="false"
    [formGroup]="demandForm"
    [controlName]="demandRegisterProps.interestFlow"
    [disabled]="isSwapFieldsReadonly"
    (sendSelectedOption)="handleOptionChange($event, 'interestFlow')"
    [placeholder]="tk.User.Select | t">
  </app-select>
</div> -->

      <!-- Campo Fluxo de Amortização - para SWAP -->
      <!-- <div
  class="ndf-management-item__content__item ndf-management-item__content__item--border"
  [ngClass]="{
    'ndf-management-item__content__item--readonly': isSwapFieldsReadonly
  }">
  <span *ngIf="isSwapFieldsReadonly">
    {{ getAmortizationFlowLabel(demandForm.get(demandRegisterProps.amortizationFlow)?.value) || ' - ' }}
  </span>
  <app-select
    *ngIf="!isSwapFieldsReadonly"
    class="w-100 custom-disabled-no-opacity"
    [options]="amortizationFlowOptions"
    [selectedOption]="selectedAmortizationFlow"
    [theme]="'clean'"
    [hidden]="isSwapFieldsReadonly"
    [error]="false"
    [formGroup]="demandForm"
    [controlName]="demandRegisterProps.amortizationFlow"
    [disabled]="isSwapFieldsReadonly"
    (sendSelectedOption)="handleOptionChange($event, 'amortizationFlow')"
    [placeholder]="tk.User.Select | t">
  </app-select>
</div> -->

      <!-- Campo Número de Amortizações - para SWAP -->
      <!-- <div
  class="ndf-management-item__content__item ndf-management-item__content__item--border"
  [ngClass]="{
    'ndf-management-item__content__item--readonly': isSwapFieldsReadonly
  }">
  <span *ngIf="isSwapFieldsReadonly">
    {{ demandForm.get(demandRegisterProps.numberOfAmortizations)?.value || ' - ' }}
  </span>
  <app-input
    *ngIf="!isSwapFieldsReadonly"
    [type]="'number'"
    [theme]="'clean'"
    [hidden]="isSwapFieldsReadonly"
    [value]="demandForm.get(demandRegisterProps.numberOfAmortizations)?.value || ''"
    [disabled]="isSwapFieldsReadonly"
    [placeholder]="(tk.Management.NdfAmortizations | t) || ''"
    [controlName]="demandRegisterProps.numberOfAmortizations"
    [required]="false"
    (sendInputValue)="handleInputNumber($event, demandRegisterProps.numberOfAmortizations)" />
</div> -->
      <!-- INÍCIO referencia -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <app-input
          [pTooltip]="ndfOperation?.reference"
          tooltipPosition="top"
          style="width: 100%"
          [type]="'text'"
          [placeholder]="tk.General.TypeObservation | t"
          [controlName]="demandRegisterProps.reference"
          [label]="''"
          [theme]="'clean'"
          [disabled]="false"
          [required]="false"
          (sendInputValue)="handleInputText($event, 'reference')">
        </app-input>
      </div>

      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"></div>

      <!-- INICIO volume protegido CAP -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        <p class="mb-0">
          {{
            isCallSpread || isCallVanilla
              ? '0,00'
              : (ndfOperation?.protectedVolumeUntilCap | number: '1.2-2' || 0)
          }}
        </p>
      </div>
      <!-- FIM volume protegido CAP -->
      <!-- INÍCIO Corridos/Úteis -->
      <div class="d-flex">
        <div class="w-100">
          <div
            class="ndf-management-item__content__item ndf-management-item__content__item--border justify-content-center">
            <p class="mb-0">
              {{ datePTAXExceeded?.lastDatePTAXExceededCap | date: 'dd/MM/yyyy' || '-' }}
            </p>
          </div>
        </div>
        <div class="w-100">
          <div
            class="ndf-management-item__content__item ndf-management-item__content__item--border justify-content-center">
            <p class="mb-0">
              {{ datePTAXExceeded?.daysUntilLastPTAXExceedCap || '-' }}

              <template *ngIf="datePTAXExceeded?.daysUntilLastPTAXExceedCap">
                {{
                  (datePTAXExceeded?.daysUntilLastPTAXExceedCap || 0) === 1
                    ? (tk.General.Day | t)
                    : (tk.Management.Days | t)
                }}
              </template>
            </p>
          </div>
        </div>
      </div>
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"></div>
      <!-- INÍCIO Notional BRL ref -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [style.justify-content]="isSwapAndCDI || isCallSpread ? 'space-between' : 'flex-end'">
        <i
          *ngIf="isSwapAndCDI && isDueDateInFuture"
          class="pi pi-exclamation-triangle"
          pTooltip="Foi considerado a projeção do DI para o periodo até o vencimento em {{
            ndfOperation?.estimetedCdiForPeriod
          }}%">
        </i>
        <i
          *ngIf="isCallSpread"
          class="pi pi-exclamation-triangle"
          pTooltip="{{ tk.Management.CostConsiderationLowStrike | t }}">
        </i>
        <span [style.text-align]="'right'" [style.width]="'100%'">
          {{ ndfOperation?.notionalBRLByReferenceRate | number: '1.2-2' || '0' }}
        </span>
      </div>

      <!-- FIM Notional BRL ref -->
      <!-- INÍCIO custo nominal -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [style.justify-content]="isSwapAndCDI || isCallSpread ? 'space-between' : 'flex-end'">
        <i
          *ngIf="isSwapAndCDI && isDueDateInFuture"
          class="pi pi-exclamation-triangle"
          pTooltip="Foi considerado a projeção do DI para o periodo até o vencimento em {{
            ndfOperation?.estimetedCdiForPeriod
          }}%">
        </i>
        <i
          *ngIf="isCallSpread"
          class="pi pi-exclamation-triangle"
          pTooltip="{{ tk.Management.CostConsiderationLowStrike | t }}">
        </i>
        <span [style.text-align]="'right'" [style.width]="'100%'">
          {{ ndfOperation?.nominalCost | number: '1.2-2' || '0' }}
        </span>
      </div>
      <!-- FIM custo nominal -->
      <!-- INÍCIO custo nominal flat -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [style.justify-content]="isSwapAndCDI || isCallSpread ? 'space-between' : 'flex-end'">
        <i
          *ngIf="isSwapAndCDI && isDueDateInFuture"
          class="pi pi-exclamation-triangle"
          pTooltip="Foi considerado a projeção do DI para o periodo até o vencimento em {{
            ndfOperation?.estimetedCdiForPeriod
          }}%">
        </i>
        <i
          *ngIf="isCallSpread"
          class="pi pi-exclamation-triangle"
          pTooltip="{{ tk.Management.CostConsiderationLowStrike | t }}">
        </i>
        <span [style.text-align]="'right'" [style.width]="'100%'">
          {{ isSwapAndCDI ? 'DI + ' : ''
          }}{{ ndfOperation?.nominalCostFlatRounded || 0 | number: '1.2-2' }}%
        </span>
      </div>
      <!-- FIM custo nominal flat -->
      <!-- INÍCIO custo nominal a.a -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"
        [style.justify-content]="isSwapAndCDI || isCallSpread ? 'space-between' : 'flex-end'">
        <i
          *ngIf="isSwapAndCDI && isDueDateInFuture"
          class="pi pi-exclamation-triangle"
          pTooltip="Foi considerado a projeção do DI para o periodo até o vencimento em {{
            ndfOperation?.estimetedCdiForPeriod
          }}%">
        </i>
        <i
          *ngIf="isCallSpread"
          class="pi pi-exclamation-triangle"
          pTooltip="{{ tk.Management.CostConsiderationLowStrike | t }}">
        </i>
        <span [style.text-align]="'right'" [style.width]="'100%'">
          {{ isSwapAndCDI ? 'DI + ' : ''
          }}{{ ndfOperation?.nominalCostAnnualizedRounded || 0 | number: '1.2-2' }}%
        </span>
      </div>
      <!-- FIM custo nominal a.a -->

      <!-- Adicione os campos específicos para SWAP após os campos existentes -->
      <!-- Fluxo de Juros -->
      <!-- <div class="ndf-management-item__content__item ndf-management-item__content__item--border"> -->
      <!-- <span>{{ getInterestFlowLabel(ndfOperation?.interestFlow) }}</span>
</div> -->

      <!-- Fluxo de Amortização -->
      <!-- <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
  <span>{{ getAmortizationFlowLabel(ndfOperation?.amortizationFlow) }}</span>
</div> -->

      <!-- Campos para Call Spread e Call Vanilla -->

      <!-- APÓS o campo Premio existente, adicione esses campos -->

      <!-- Campo Prêmio % -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border text-right">
        <span *ngIf="isPremiumFieldVisible">
          {{ ndfOperation?.premiumPercentageRounded | vaultFormatPercent: 2 }}
        </span>
        <span *ngIf="!isPremiumFieldVisible">-</span>
      </div>

      <!-- Campo Prêmio % a.a. -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border text-right">
        <span *ngIf="isPremiumFieldVisible">
          {{ ndfOperation?.annualizedPremiumPercentageRounded | vaultFormatPercent: 2 }}
        </span>
        <span *ngIf="!isPremiumFieldVisible">-</span>
      </div>
      <!-- Proteção cambial máxima % -->
      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border text-right">
        <span>{{
          ndfOperation?.maximumFXProtectionPercentageRounded | vaultFormatPercent: 2
        }}</span>
      </div>

      <!-- Variação acima limitador % -->
      <!-- <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border text-right">
        <span>{{ ndfOperation?.variationAboveLimiterPercentage | vaultFormatPercent: 2 }}</span>
      </div> -->

      <!-- Variação acima limitador R$ -->
      <!-- <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border text-right">
        <span>{{ ndfOperation?.variationAboveLimiterAmount | number: '1.2-2' }}</span>
      </div> -->

      <div
        class="ndf-management-item__content__item ndf-management-item__content__item--border"></div>

      <!-- INÍCIO Novos campos de liquidação -->
      <!-- INÍCIO Data da liquidação -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.settlementDate || null | vaultDate }}
      </div>
      <!-- FIM Data da liquidação -->

      <!-- INÍCIO Notional da liquidação -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.settlementNotional | number: '1.2-2' || 0 }}
      </div>
      <!-- FIM Notional da liquidação -->

      <!-- INÍCIO Taxa de Liquidação -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.settlementRate | number: '1.4-4' || 0 }}
      </div>
      <!-- FIM Taxa de Liquidação -->

      <!-- INÍCIO Spot -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.settlementSpot | number: '1.4-4' || 0 }}
      </div>
      <!-- FIM Spot -->

      <!-- INÍCIO Ajuste Bruto -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.totalAmount | number: '1.2-2' || 0 }}
      </div>
      <!-- FIM Ajuste Bruto -->

      <!-- INÍCIO IRRF -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.withholdingTax | number: '1.2-2' || 0 }}
      </div>
      <!-- FIM IRRF -->

      <!-- INÍCIO IR a pagar -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.incomeTaxPayable | number: '1.2-2' || 0 }}
      </div>
      <!-- FIM IR a pagar -->

      <!-- INÍCIO Ajuste líquido -->
      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ ndfOperation?.netAmount | number: '1.2-2' || 0 }}
      </div>
      <!-- FIM Ajuste líquido -->
      <!-- FIM Novos campos de liquidação -->

      <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
        {{ tk.Management.NdfCostPerYearPerScenario | t }}
      </div>
      <!-- INÍCIO reference fees -->
      <ng-container *ngFor="let annualCostByScenario of ndfOperation?.annualCostByScenarios">
        <div class="ndf-management-item__content__item ndf-management-item__content__item--border">
          {{ (annualCostByScenario?.annualCost || 0) / 100 | percent: '1.2-2' || '' }}
        </div>
      </ng-container>
      <!-- FIM reference fees -->
    </form>
  </div>
  <div
    class="ndf-management-item__header"
    (dblclick)="handleDoubleClickHeader()"
    (longPress)="handleLongPress()"
    *ngIf="ndfOperation?.colapsed">
    <div class="d-flex align-items-center">
      <app-action-menu
        [items]="actionIcons"
        [horientation]="'vertical'"
        (sendItemClick)="handleActionMenu($event)"></app-action-menu>
    </div>
  </div>
</div>
